import { isNil } from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const generateCirclePath = (center, radius, points = 64) => {
  const earthRadius = 6371000; // meters
  const lat = center.lat * Math.PI / 180;
  const lng = center.lng * Math.PI / 180;
  const d = radius / earthRadius;

  const path = [];
  for (let i = 0; i <= points; i++) {
    const angle = (i * 2 * Math.PI) / points;
    const latOffset = Math.asin(Math.sin(lat) * Math.cos(d) + Math.cos(lat) * Math.sin(d) * Math.cos(angle));
    const lngOffset = lng + Math.atan2(Math.sin(angle) * Math.sin(d) * Math.cos(lat), Math.cos(d) - Math.sin(lat) * Math.sin(latOffset));

    path.push({
      lat: latOffset * 180 / Math.PI,
      lng: lngOffset * 180 / Math.PI,
      altitude: 1000
    });
  }
  return path;
};

const RenderCircles3D = (props) => {
  const { mapReferenceThreed, circles } = props;

  useEffect(() => {
    if (!mapReferenceThreed || typeof mapReferenceThreed.append !== 'function') {
      console.warn("Invalid mapReferenceThreed:", mapReferenceThreed);
      return;
    }

    renderCircles();
  }, [mapReferenceThreed, circles]);

  async function renderCircles() {
    const { Polygon3DElement } = await google.maps.importLibrary("maps3d");
    circles.forEach(circle => {
      const geoJson = circle?.geoJson && JSON.parse(circle.geoJson);
      if (!geoJson) return;

      const [lng, lat] = geoJson.features[0].geometry.coordinates;
      const radius = geoJson.features[0].properties.radius;
      const rawColor = geoJson.features[0].properties.line.color || '#0009F9';
      const color = rawColor.length === 9 ? '#' + rawColor.slice(3, 9) : rawColor;

      const path = generateCirclePath({ lat, lng }, radius);

      const polygonOptions = {
        strokeColor: geoJson?.features[0]?.properties?.line?.color + '80' || "#EA433580",
        strokeWidth: 5,
        fillColor: geoJson?.features[0]?.properties?.line?.fill + '20' || "#EA433520",
        // altitudeMode: "ABSOLUTE",  // Must be ABSOLUTE for wall effect
        altitudeMode: "CLAMP_TO_GROUND",//"RELATIVE", //"CLAMP_TO_GROUND",// "ABSOLUTE", // or "CLAMP_TO_GROUND" / "RELATIVE"
        extruded: true,
        drawsOccludedSegments: true,
      }

      const towerPolygon = new google.maps.maps3d.Polygon3DElement(polygonOptions);
      towerPolygon.outerCoordinates = path
      props.mapReferenceThreed.append(towerPolygon);

      circle.mapObj = () => towerPolygon;

      towerPolygon.addEventListener('click', () => {
        console.log('3D Circle Polygon clicked');
      });
    });
  }

  return null;
};

const mapStateToProps = (state) => ({
  circles: state.circles,

});

export default connect(mapStateToProps)(RenderCircles3D);
